<!-- 移动端 品类抽屉 -->
<template>
  <el-drawer el-drawer :visible="visible" direction="rtl" size="85%" class="mobile-category-drawer" :show-close="true" @close="$emit('visibleChange', false)">
    <template v-for="item in categoryTree">
      <p :key="item.id" class="mobile-category-title">{{item.name}}</p>
      <div :key="item.id" class="f fw-w">
        <div v-for="category in item.childList || []" :key="category.id" class="mobile-category-box" @click="toCategoryDetail(category)">
          <img :src="category.imgUrl">
          <p class="ellipsis2">{{category.name}}</p>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import bus from '@/util/bus'
export default {
  model: {
    prop: 'visible',
    event: 'visibleChange'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    categoryTree() {
      return this.$store.state.common.categoryTree
    }
  },
  methods: {
    toCategoryDetail(category) {
      this.$emit('visibleChange', false)
      if (this.$route.path === '/mall/category-detail') {
        return bus.$emit('mobileCategoryChange', category)
      }
      this.$router.push({
        path: '/mall/category-detail',
        query: {
          secondCategoryId: category.categoryId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-category-title{
  font-weight: 500;
  font-size: .30rem;
  padding-bottom: .28rem;
}
.mobile-category-box{
  width: 33%;
  height: 2.1rem;
  display: inline-block;
  margin-bottom: .4rem;
  img{
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 100%;
    margin: 0 auto 0.08rem auto;
    display: block;
  }
  p{
    text-align: center;
    white-space: pre-wrap;
  }
}
</style>
<style>
.mobile-category-drawer .el-drawer__body{
  padding: 0 .3rem;
}
</style>
